const mutations = {
  onGet (state, payload) {
    payload.event.context.permissions = payload.response.data.data.data
    let permissions = payload.event.context.permissions
    for (let i = 0; i < permissions.length; i++) {
      let item = permissions[i]
      permissions[i] = {id: item.id, name: item.name}
    }
  },
  onGetUsers (state, payload) {
    payload.event.context.users = payload.response.data.data.data
    payload.event.context.users.forEach(item => {
      item.permissionsOriginal = item.permissions.slice()
    })
    payload.event.context.options.itemsPerPage = parseInt(payload.response.data.data.per_page)
    payload.event.context.options.page = payload.response.data.data.current_page
    payload.event.context.options.total = payload.response.data.data.total
    payload.event.context.loadTable = false
  },
  onGetUserById (state, payload) {
    payload.event.context.editedItem = Object.assign({}, payload.response.data.data)
    let permissions = payload.event.context.editedItem.permissions
    for (let i = 0; i < permissions.length; i++) {
      let item = permissions[i]
      permissions[i] = {id: item.id, name: item.name}
    }
    payload.event.context.filterPermissions()
    payload.event.context.loadItem = false
  },
  onPost (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.close()
    payload.event.context.get()
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loading = false
  }
}

export default mutations